module.exports = __webpack_public_path__ + "static/media/crypto.8f64c7c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/crypto.svg
// module id = 3077
// module chunks = 0